module.exports = __webpack_public_path__ + "img/img_biaoqian@2x.4602f962.png";